import MemberActionTypes from './types';

const initialState = {
  membersData: [],
  loading: false,
  hasNextPage: false,
  currentPage: 1,
  pageSize: 100,
  searching: false,
  searchQuery: '',
};

const memberReducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case MemberActionTypes.SET_MEMBER_STATE: {
      return { ...state, ...payload };
    }
    default: {
      return state;
    }
  }
};

export default memberReducer;
